import * as lc from '../../../../../utils/lodashCustom';

// eslint-disable-next-line import/prefer-default-export
export function restructureTopUserModel(state, data) {
  return {
    id: lc.get(data, 'id'),
    username: lc.get(data, 'username'),
    avatarPath: lc.get(data, 'profile.avatar_path'),
    total: lc.get(data, 'total')
  };
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/topUsers/services/TopUsersService/restructuring/index.js